import { concatLowerCase } from '@Utils/String';

export function contextFromMetadata(metadata = {}) {
  return metadata.isViewPreview ?
    `${concatLowerCase(metadata.title || metadata.context)}` :
    metadata.context;
}
